//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Charlson_info",

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/Charlson_info.vue